import React, { useEffect, useMemo, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import AuthService from '../../services/api/auth';

import { pubKeySelector } from '../../redux/payment/selector';
import { setPubKey } from '../../redux/payment/actions';

import CardSetupForm from './CardSetupForm';
import ErrorList from '../ErrorList';
import LoadingModal from '../LoadingModal';

const CardContext = ({ pubKey, onSetPubKey, history }) => {
    const [errors, setErrors] = useState([]);
    const stripePromise = useMemo(() => (pubKey && loadStripe(pubKey)) || null, [pubKey]);

    const getPubKey = useCallback(() => {
        if (!pubKey) {
            try {
                AuthService.getPubKey().then(pubKey => {
                    onSetPubKey(pubKey);
                });
            } catch (error) {
                const { data } = error;
                if (data && data.message) {
                    setErrors([data.message]);
                }
            }
        }
    }, [onSetPubKey, pubKey]);

    useEffect(() => {
        getPubKey();
    }, [getPubKey]);

    if (!pubKey) {
        return <LoadingModal loading />;
    }

    return (
        <>
            {window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}
            <Elements stripe={stripePromise}>
                <CardSetupForm pubKey={pubKey} history={history} />
            </Elements>
        </>
    );
};

const mapStateToProps = state => ({
    pubKey: pubKeySelector(state),
});

const mapActionsToProps = dispatch => ({
    onSetPubKey: bindActionCreators(setPubKey, dispatch),
});

export default connect(mapStateToProps, mapActionsToProps)(CardContext);
